/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'
import {getPathWithLocale} from '../utils/url'

const useMulticountryUtils = () => {
    const {locale, buildUrl} = useMultiSite()

    /**
     * Build the path for the current locale
     * @returns {string} - The localized path.
     */
    const buildLocalizedUrl = (pathname, localeId = null) => {
        const location = {
            pathname,
            search: '',
        }
        return getPathWithLocale(localeId || locale.id, buildUrl, {
            location,
        })
    }

    return {
        buildLocalizedUrl,
    }
}

export default useMulticountryUtils
